/* One viewport-clamped, accessible hint for asynchronously mounted wishlist buttons. */
(() => {
  const selector='xb-wishlist-button-collection button[aria-label]';
  const ready=new WeakSet(); let tip, active, queued=false, hideTimer, revealFrame;
  const labels={de:['Zur Wunschliste hinzufügen','Von der Wunschliste entfernen'],en:['Add to wishlist','Remove from wishlist'],nl:['Aan verlanglijst toevoegen','Van verlanglijst verwijderen'],fr:['Ajouter aux favoris','Retirer des favoris'],it:['Aggiungi ai preferiti','Rimuovi dai preferiti'],es:['Añadir a favoritos','Eliminar de favoritos'],sv:['Lägg till i önskelistan','Ta bort från önskelistan']};
  function hide(){
    if(!active)return;
    document.documentElement.classList.remove('vnk-wishlist-hint-active');
    const ids=(active.getAttribute('aria-describedby')||'').split(/\s+/).filter(id=>id&&id!==tip.id);
    if(ids.length)active.setAttribute('aria-describedby',ids.join(' '));else active.removeAttribute('aria-describedby');
    active=null;cancelAnimationFrame(revealFrame);tip.classList.remove('is-visible');
    clearTimeout(hideTimer);hideTimer=setTimeout(()=>{if(!active)tip.hidden=true;},180);
  }
  function show(button){
    hide();clearTimeout(hideTimer);active=button;
    document.documentElement.classList.add('vnk-wishlist-hint-active');
    const text=button.getAttribute('aria-label')||'';
    const language=document.documentElement.lang.toLowerCase().split('-')[0];
    tip.textContent=(labels[language]||labels.en)[/remove|entfernen|retirer|verwijder|rimuov|elimin|ta bort/i.test(text)?1:0];
    tip.hidden=false;
    const bounds=button.getBoundingClientRect(), box=tip.getBoundingClientRect();
    const left=Math.max(12,Math.min(innerWidth-box.width-12,bounds.left+bounds.width/2-box.width/2));
    const above=bounds.top-box.height-10>=8;
    tip.style.left=left+'px';tip.style.top=(above?bounds.top-box.height-10:bounds.bottom+10)+'px';
    tip.classList.toggle('is-above',above);
    tip.style.setProperty('--pointer-left',Math.max(14,Math.min(box.width-14,bounds.left+bounds.width/2-left))+'px');
    revealFrame=requestAnimationFrame(()=>{if(active===button)tip.classList.add('is-visible');});
    button.setAttribute('aria-describedby',((button.getAttribute('aria-describedby')||'')+' '+tip.id).trim());
  }
  function init(){
    queued=false;
    if(active&&!active.isConnected)hide();
    const buttons=document.querySelectorAll(selector);if(!buttons.length)return;
    if(!tip){tip=document.createElement('span');tip.id='vnk-wishlist-tip';tip.className='vnk-wishlist-tip';tip.setAttribute('role','tooltip');tip.hidden=true;document.body.appendChild(tip);}
    buttons.forEach(button=>{
      if(ready.has(button))return;ready.add(button);
      button.addEventListener('pointerenter',event=>{if(event.pointerType!=='touch')show(button);});
      button.addEventListener('pointerleave',()=>{if(document.activeElement!==button&&active===button)hide();});
      button.addEventListener('focus',()=>show(button));
      button.addEventListener('blur',()=>{if(active===button)hide();});
      button.addEventListener('keydown',event=>{if(event.key==='Escape')hide();});
    });
  }
  function start(){init();new MutationObserver(records=>{if(active&&records.some(record=>record.target===active&&record.attributeName==='aria-label'))show(active);if(!queued){queued=true;requestAnimationFrame(init);}}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-label']});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  window.addEventListener('resize',hide,{passive:true});
  document.addEventListener('scroll',hide,{capture:true,passive:true});
})();
